class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    
    $('.trikot_upsell').each(function(){
      let $this = $(this),
        trikot_id = $this.attr('data-n'),
        main_trikot = $('.trikot_main[data-n="'+trikot_id+'"]');

      if(main_trikot.length == 0){
        $this.find('.cart-item__quantity').find('quantity-input.quantity').addClass('visibility-hidden');
        $this.find('.cart-item__quantity').removeClass('visibility-hidden');
      }

    });
    this.addEventListener('click', (event) => {
      event.preventDefault();
       
       var hastrikot = this.closest('.cart-item').getAttribute('data-t');
       var trikot_no = this.closest('.cart-item').getAttribute('data-n');
       var trikot_id = this.closest('.cart-item').getAttribute('id');      
       let line_no = this.dataset.index;
       

       var qty = 0;
       var updates_id = [];
       let trikot_main_id = 0;
       var data = { updates: {} };
       var all_line_nr = [];

       var tid = [];
       var tids = [];
       var updateData = {}

      // hastrikot = 'false';
                  
       if(hastrikot == 'true'){ 
          document.querySelectorAll(`#CartItem-${line_no} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
                  
          const items = document.querySelectorAll(`.cart-items .cart-item[data-n='${trikot_no}']`);
          items.forEach(element =>  { 
              let data_id = element.getAttribute('data-id');
              let data_key = element.getAttribute('data-key');
              //console.log('data_id',data_id,data_key);
              tid.push(data_id);  
              tids.push(data_key);
          });
         
         /*$(`.cart-items .cart-item[data-n=${trikot_no}]`).each(function(){
              tid.push($(this).data('id'));  
              tids.push($(this).data('key')+':0');
          });*/ 
          
          for(var i=0; i < tids.length; i++){       
              updateData[tids[i]] = 0;
          }
          
         //console.log(updateData);

          jQuery.post(window.Shopify.routes.root + 'cart/update.js',                      
            { updates: updateData }      
          ).done(function( data ) {            
            var response = $.parseJSON(data);
           
            var total_price = Shopify.formatMoney(response.total_price, "CHF {{amount}}");
            let item_count = response.item_count;
            if(item_count == 0){
              window.location.reload();
            }
            else {
              
                document.querySelector('#main-cart-footer .totals__subtotal-value').textContent = total_price;
                document.querySelector('.megamenu_right .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;
                document.querySelector('.header .header__icons .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;
                
                let removeelement = document.querySelectorAll(`.cart-items .cart-item[data-n='${trikot_no}']`);
                removeelement.forEach(r_element =>  {             
                  r_element.remove(); 
                });  
    
                const update_items = document.querySelectorAll('.cart-items tbody tr.cart-item');                    
                for (let i = 0,j = 1; i <= update_items.length - 1; i++,j++) {                                 
                   update_items[i].setAttribute("id", `CartItem-${j}`);
                   update_items[i].querySelector('cart-remove-button').setAttribute("data-index", j);
                   update_items[i].querySelector('.cart-item__quantity .quantity__input').setAttribute("data-index", j);       
                }
              
            }

          });
         
         /*
          const items = document.querySelectorAll('.cart-items tbody tr.cart-item');
          for (let i = 0; i <= items.length - 1; i++) {
               
               if(trikot_no == items[i].getAttribute('data-n') && items[i].getAttribute('data-t') == 'false'){                                
                 updates_id.push(items[i].getAttribute('data-id'));                 
               }
               if(trikot_no == items[i].getAttribute('data-n') && items[i].getAttribute('data-t') == 'true'){ 
                 trikot_main_id = items[i].getAttribute('data-id');                 
               }
               qty = items[i].querySelector('.quantity__input').getAttribute('value');               
               all_line_nr.push(qty);                
          }        
                 
         // For only Main
         if(updates_id.length == 0){
           this.closest('cart-items').updateQuantity(this.dataset.index, 0);
         }
         // For only one trikot upsell  
         else if(updates_id.length == 1){

           var updates_line_1 = parseInt(line_no) + 1;           

           var main_trikot_index = parseInt(line_no) - 1;
           var first_upsell_index = parseInt(line_no);
           
           all_line_nr[main_trikot_index] = 0;
           all_line_nr[first_upsell_index] = 0;           
           
          var updates_id_1 = updates_id[0];
          jQuery.post(window.Shopify.routes.root + 'cart/update.js',
            //"updates["+updates_id_1+"]=0&updates["+trikot_main_id+"]=0"             
            { updates: all_line_nr }      
          ).done(function( data ) {            
            var response = $.parseJSON(data);
           
            var total_price = Shopify.formatMoney(response.total_price, "CHF {{amount}}");
            let item_count = response.item_count;
            if(item_count == 0){
              window.location.reload();
            }
            else {
            document.querySelector('#main-cart-footer .totals__subtotal-value').textContent = total_price;
            document.querySelector('.megamenu_right .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;
            document.querySelector('.header .header__icons .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;

            var delete_main = document.querySelector(`#CartItem-${line_no}`);
            delete_main.parentNode.removeChild(delete_main);
            var delete_child1 = document.querySelector(`#CartItem-${updates_line_1}`);
            delete_child1.parentNode.removeChild(delete_child1);            
            
            const update_items = document.querySelectorAll('.cart-items tbody tr.cart-item');                    
            for (let i = 0,j = 1; i <= update_items.length - 1; i++,j++) {                                 
                 update_items[i].setAttribute("id", `CartItem-${j}`);
                 update_items[i].querySelector('cart-remove-button').setAttribute("data-index", j);
                 update_items[i].querySelector('.cart-item__quantity .quantity__input').setAttribute("data-index", j);       
            }                
            }   

          });
           
         }
         // For only two trikot upsell  
         else if(updates_id.length == 2){
           
           var updates_id_1 = updates_id[0];
           var updates_id_2 = updates_id[1]; 

           var updates_line_1 = parseInt(line_no) + 1;
           var updates_line_2 = parseInt(line_no) + 2; 

           var main_trikot_index = parseInt(line_no) - 1;
           var first_upsell_index = parseInt(line_no);
           var second_upsell_index = parseInt(line_no) + 1;
                      
           all_line_nr[main_trikot_index] = 0;
           all_line_nr[first_upsell_index] = 0;
           all_line_nr[second_upsell_index] = 0;
         
          jQuery.post(window.Shopify.routes.root + 'cart/update.js',
            { updates: all_line_nr }      
          ).done(function( data ) {            
            var response = $.parseJSON(data);
           
            var total_price = Shopify.formatMoney(response.total_price, "CHF {{amount}}");
            let item_count = response.item_count;

            if(item_count == 0){
              window.location.reload();
            }
            else {
            document.querySelector('#main-cart-footer .totals__subtotal-value').textContent = total_price;
            document.querySelector('.megamenu_right .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;
            document.querySelector('.header .header__icons .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;

            var delete_main = document.querySelector(`#CartItem-${line_no}`);
            delete_main.parentNode.removeChild(delete_main);
            var delete_child1 = document.querySelector(`#CartItem-${updates_line_1}`);
            delete_child1.parentNode.removeChild(delete_child1);
            var delete_child2 = document.querySelector(`#CartItem-${updates_line_2}`);
            delete_child2.parentNode.removeChild(delete_child2);
            
            const update_items = document.querySelectorAll('.cart-items tbody tr.cart-item');                     
            for (let i = 0,j = 1; i <= update_items.length - 1; i++,j++) {                              
                 update_items[i].setAttribute("id", `CartItem-${j}`);
                 update_items[i].querySelector('cart-remove-button').setAttribute("data-index", j);
                 update_items[i].querySelector('.cart-item__quantity .quantity__input').setAttribute("data-index", j);       
            }    
            }
           
          });
     
         }
        // For only three trikot upsell  
           
         else if(updates_id.length == 3){
           var updates_id_1 = updates_id[0];
           var updates_id_2 = updates_id[1];
           var updates_id_3 = updates_id[2];

           var updates_line_1 = parseInt(line_no) + 1;
           var updates_line_2 = parseInt(line_no) + 2;
           var updates_line_3 = parseInt(line_no) + 3;

           var main_trikot_index = parseInt(line_no) - 1;
           var first_upsell_index = parseInt(line_no);
           var second_upsell_index = parseInt(line_no) + 1;
           var third_upsell_index = parseInt(line_no) + 2;
           
           all_line_nr[main_trikot_index] = 0;
           all_line_nr[first_upsell_index] = 0;
           all_line_nr[second_upsell_index] = 0;
           all_line_nr[third_upsell_index] = 0;
          
           jQuery.post(window.Shopify.routes.root + 'cart/update.js',
            { updates: all_line_nr }     
          ).done(function( data ) {            
            var response = $.parseJSON(data);
           
            var total_price = Shopify.formatMoney(response.total_price, "CHF {{amount}}");
            let item_count = response.item_count;
           
           if(item_count == 0){
              window.location.reload();
            }
            else {
            document.querySelector('#main-cart-footer .totals__subtotal-value').textContent = total_price;
            document.querySelector('.megamenu_right .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;
            document.querySelector('.header .header__icons .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;

            var delete_main = document.querySelector(`#CartItem-${line_no}`);
            delete_main.parentNode.removeChild(delete_main);
            var delete_child1 = document.querySelector(`#CartItem-${updates_line_1}`);
            delete_child1.parentNode.removeChild(delete_child1);
            var delete_child2 = document.querySelector(`#CartItem-${updates_line_2}`);
            delete_child2.parentNode.removeChild(delete_child2);
            var delete_child3 = document.querySelector(`#CartItem-${updates_line_3}`);
            delete_child3.parentNode.removeChild(delete_child3);

            const update_items = document.querySelectorAll('.cart-items tbody tr.cart-item');                    
            for (let i = 0,j = 1; i <= update_items.length - 1; i++,j++) {                          
                 update_items[i].setAttribute("id", `CartItem-${j}`);
                 update_items[i].querySelector('cart-remove-button').setAttribute("data-index", j);
                 update_items[i].querySelector('.cart-item__quantity .quantity__input').setAttribute("data-index", j);       
            }  
              
            }
            

          });
           
         }
         // For only four trikot upsell  
         else if(updates_id.length == 4){
           var updates_id_1 = updates_id[0];
           var updates_id_2 = updates_id[1];
           var updates_id_3 = updates_id[2];
           var updates_id_4 = updates_id[3];

           var updates_line_1 = parseInt(line_no) + 1;
           var updates_line_2 = parseInt(line_no) + 2;
           var updates_line_3 = parseInt(line_no) + 3;
           var updates_line_4 = parseInt(line_no) + 4;

           var main_trikot_index = parseInt(line_no) - 1;
           var first_upsell_index = parseInt(line_no);
           var second_upsell_index = parseInt(line_no) + 1;
           var third_upsell_index = parseInt(line_no) + 2;
           var fourth_upsell_index = parseInt(line_no) + 3;
           
           all_line_nr[main_trikot_index] = 0;
           all_line_nr[first_upsell_index] = 0;
           all_line_nr[second_upsell_index] = 0;
           all_line_nr[third_upsell_index] = 0;
           all_line_nr[fourth_upsell_index] = 0;
          
          jQuery.post(window.Shopify.routes.root + 'cart/update.js',
            { updates: all_line_nr }  
          ).done(function( data ) {            
            var response = $.parseJSON(data);
           
            var total_price = Shopify.formatMoney(response.total_price, "CHF {{amount}}");
            let item_count = response.item_count;
           
            if(item_count == 0){
              window.location.reload();
            }
            else {
            document.querySelector('#main-cart-footer .totals__subtotal-value').textContent = total_price;
            document.querySelector('.megamenu_right .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;
            document.querySelector('.header .header__icons .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;

            var delete_main = document.querySelector(`#CartItem-${line_no}`);
            delete_main.parentNode.removeChild(delete_main);
            var delete_child1 = document.querySelector(`#CartItem-${updates_line_1}`);
            delete_child1.parentNode.removeChild(delete_child1);
            var delete_child2 = document.querySelector(`#CartItem-${updates_line_2}`);
            delete_child2.parentNode.removeChild(delete_child2);
            var delete_child3 = document.querySelector(`#CartItem-${updates_line_3}`);
            delete_child3.parentNode.removeChild(delete_child3);
            var delete_child4 = document.querySelector(`#CartItem-${updates_line_4}`);
            delete_child4.parentNode.removeChild(delete_child4);

            const update_items = document.querySelectorAll('.cart-items tbody tr.cart-item');                   
            for (let i = 0,j = 1; i <= update_items.length - 1; i++,j++) {                             
                 update_items[i].setAttribute("id", `CartItem-${j}`);
                 update_items[i].querySelector('cart-remove-button').setAttribute("data-index", j);
                 update_items[i].querySelector('.cart-item__quantity .quantity__input').setAttribute("data-index", j);       
            }  
              
            }
            

          });
           
         }

         // For only Five trikot upsell  
         else if(updates_id.length == 5){
           var updates_id_1 = updates_id[0];
           var updates_id_2 = updates_id[1];
           var updates_id_3 = updates_id[2];
           var updates_id_4 = updates_id[3];
           var updates_id_5 = updates_id[4];

           var updates_line_1 = parseInt(line_no) + 1;
           var updates_line_2 = parseInt(line_no) + 2;
           var updates_line_3 = parseInt(line_no) + 3;
           var updates_line_4 = parseInt(line_no) + 4;
           var updates_line_5 = parseInt(line_no) + 5;

           var main_trikot_index = parseInt(line_no) - 1;
           var first_upsell_index = parseInt(line_no);
           var second_upsell_index = parseInt(line_no) + 1;
           var third_upsell_index = parseInt(line_no) + 2;
           var fourth_upsell_index = parseInt(line_no) + 3;
           var fifth_upsell_index = parseInt(line_no) + 4;
           
           all_line_nr[main_trikot_index] = 0;
           all_line_nr[first_upsell_index] = 0;
           all_line_nr[second_upsell_index] = 0;
           all_line_nr[third_upsell_index] = 0;
           all_line_nr[fourth_upsell_index] = 0;
           all_line_nr[fifth_upsell_index] = 0;
          
          jQuery.post(window.Shopify.routes.root + 'cart/update.js',
            { updates: all_line_nr }     
          ).done(function( data ) {            
            var response = $.parseJSON(data);
           
            var total_price = Shopify.formatMoney(response.total_price, "CHF {{amount}}");
            let item_count = response.item_count;
           
            if(item_count == 0){
              window.location.reload();
            }
            else {
            document.querySelector('#main-cart-footer .totals__subtotal-value').textContent = total_price;
            document.querySelector('.megamenu_right .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;
            document.querySelector('.header .header__icons .header__icon--cart .cart-count-bubble .item_count').textContent = item_count;

            var delete_main = document.querySelector(`#CartItem-${line_no}`);
            delete_main.parentNode.removeChild(delete_main);
            var delete_child1 = document.querySelector(`#CartItem-${updates_line_1}`);
            delete_child1.parentNode.removeChild(delete_child1);
            var delete_child2 = document.querySelector(`#CartItem-${updates_line_2}`);
            delete_child2.parentNode.removeChild(delete_child2);
            var delete_child3 = document.querySelector(`#CartItem-${updates_line_3}`);
            delete_child3.parentNode.removeChild(delete_child3);
            var delete_child4 = document.querySelector(`#CartItem-${updates_line_4}`);
            delete_child4.parentNode.removeChild(delete_child4);
            var delete_child5 = document.querySelector(`#CartItem-${updates_line_5}`);
            delete_child5.parentNode.removeChild(delete_child5);

            const update_items = document.querySelectorAll('.cart-items tbody tr.cart-item');                      
            for (let i = 0,j = 1; i <= update_items.length - 1; i++,j++) {                               
                 update_items[i].setAttribute("id", `CartItem-${j}`);
                 update_items[i].querySelector('cart-remove-button').setAttribute("data-index", j);
                 update_items[i].querySelector('.cart-item__quantity .quantity__input').setAttribute("data-index", j);       
            }               
            }
       
          });
           
         }
         */
        
         
       } else { 
         this.closest('cart-items').updateQuantity(this.dataset.index, 0);
       }
       
     
    });
  }
  
}

function handleResponse() {
  JSON.parse(this.responseText);
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        
        document.querySelector('.megamenu_right .header__icon--cart .cart-count-bubble .item_count').textContent = parsedState.item_count;
        document.querySelector('.header .header__icons .header__icon--cart .cart-count-bubble .item_count').textContent = parsedState.item_count;
        
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
